import { registerValidator } from '../validatorRegistry';

registerValidator({
  key: 'canvas-bounds',
  runsOn: ['placement', 'scale'],
  async validate(ctx) {
    if (!ctx.placedRect || !ctx.canvasDimensions) {
      return { key: 'canvas-bounds', status: 'pass', blocker: false, title: 'Bounds', message: '' };
    }

    const { x, y, width, height } = ctx.placedRect;
    const { width: cw, height: ch } = ctx.canvasDimensions;
    const margin = (ctx.productConfig && ctx.surface) ? (ctx.productConfig.safeAreas[ctx.surface]?.margin ?? 0) : 0;

    const outOfBounds = x < margin || y < margin || x + width > cw - margin || y + height > ch - margin;
    if (outOfBounds) {
      return {
        key: 'canvas-bounds', status: 'warning', blocker: false,
        title: 'Outside print area',
        message: 'Part of this image is outside the safe print area and will be cut off.',
        suggestion: 'Move or resize the image to keep it within the dashed border.',
      };
    }
    return { key: 'canvas-bounds', status: 'pass', blocker: false, title: 'Within bounds', message: 'Image is within the safe print area.' };
  },
});
